export default __webpack_public_path__ + "assets/images/price-line-icon-1ed337cb.svg";